import { LayoutGrid, Table } from 'lucide-react';
import { useShallow } from 'zustand/react/shallow';
import { Button } from '@/components/ui/button.tsx';
import { usePlantsViewFilterStore } from '@/services/store/use-plants-view-filter-store.ts';

export const PlantsLayoutToggle = () => {
  const { layout, setLayout } = usePlantsViewFilterStore(
    useShallow((state) => ({
      layout: state.layout,
      setLayout: state.setLayout,
    }))
  );

  return (
    <div className="flex rounded-md border border-gray-200 bg-white">
      <Button
        title="Card view"
        variant="ghost"
        size="sm"
        onClick={() => setLayout('grid')}
        className={`min-h-9 rounded-r-none px-3 ${
          layout === 'grid' ? 'text-gray-900' : 'text-gray-500 hover:text-gray-700'
        }`}
      >
        <LayoutGrid className="h-4 w-4" />
      </Button>
      <Button
        title="Table view"
        variant="ghost"
        size="sm"
        onClick={() => setLayout('table')}
        className={`min-h-9 rounded-l-none border-l border-gray-200 px-3 ${
          layout === 'table' ? 'text-gray-900' : 'text-gray-500 hover:text-gray-700'
        }`}
      >
        <Table className="h-4 w-4" />
      </Button>
    </div>
  );
};
